import {gsap} from "gsap";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {BrickSnake2000Symbol, SymbolArgs} from "./BrickSnake2000Symbol";

export class BrickSnake2000XWaysSymbol extends BrickSnake2000Symbol {
    private xwaysCounter: PIXI.Sprite | undefined;
    private xWays:number;

    constructor(args:SymbolArgs) {
        super(args);
        this.xWays = args.symbolSize;

    }

    public xWaysReveal():gsap.core.Timeline {
        // state :sob:
        const symbolName = BrickSnake2000.model.gameData.xWaysSymbol;
        const newSymbol =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath(symbolName))[0]);
        const xways = this.xWays;
        const xwaysCounter =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(`X_Mult/X_Mult_${xways}`)[0]);

        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();

                this.view.removeChild(this.mainSprite);
                this.symbolName = symbolName;
                this.mainSprite = newSymbol;
                this.mainSprite.alpha = 0;
                this.mainSprite.anchor.set(0.5, 0.5);
                this.view.addChildAt(this.mainSprite, 0);

                this.xwaysCounter = xwaysCounter;
                this.xwaysCounter.position.set(-55,-55);
                this.xwaysCounter.alpha = 0;
                this.view.addChildAt(this.xwaysCounter, 1);
            })
            .add(gsap.to(newSymbol, {alpha: 1, duration: 0.1}))
            .add(gsap.to(xwaysCounter, {alpha: 1, duration: 0.1}), '<')
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "XW_Win"), '<')
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }

    public moveToNormalLayer(object: PIXI.DisplayObject = this) {
        if (this.symbolName == "M1") {
            this.reelsView.layers.maskedM1.addChild(object);
            (<BrickSnake2000Symbol[]>this.reelsView.layers.maskedM1.children).sort((a, b) => {
                return ((5 - a.reelID) * a.reelPosition) - ((5 - b.reelID) * b.reelPosition);
            })
        } else {
            super.moveToNormalLayer(object);
        }
    }

    public getWinAnimationBased(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.xwaysCounter!.position.set(-24, -64);
                this.view.removeChild(this.xwaysCounter!);
                this.view.addChild(this.xwaysCounter!)
            })
            .add(super.getWinAnimationBased())
            .add(() => {
                this.xwaysCounter!.position.set(-55, -55);
                this.view.removeChild(this.xwaysCounter!);
                this.view.addChildAt(this.xwaysCounter!, 1)
            });
    }

    public restore(targetSymbol:string):void {
        const symbolName = targetSymbol;
        const newSymbol =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.getSymbolStateTexturePath(symbolName))[0]);
        const xways = this.xWays;
        const xwaysCounter =
            new PIXI.Sprite(BrickSnake2000.assetLoader.getTextures(`X_Mult/X_Mult_${xways}`)[0]);

        this.view.removeChild(this.mainSprite);
        this.symbolName = symbolName;
        this.mainSprite = newSymbol;
        this.mainSprite.anchor.set(0.5, 0.5);
        this.view.addChildAt(this.mainSprite, 0);

        this.xwaysCounter = xwaysCounter;
        this.xwaysCounter.position.set(-55,-55);
        this.view.addChildAt(this.xwaysCounter, 2);
    }
}
